// Smooth-scroll to an in-page anchor, accounting for the sticky header.
// Respects prefers-reduced-motion.

const HEADER_OFFSET = 60;

export const smoothScrollToId = (id) => {
  const target = document.getElementById(id);
  if (!target) {
    return false;
  }

  const reduce =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const top = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
  return true;
};

export default smoothScrollToId;
